import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const LINKS = [
  { label: "Обо мне", href: "#about" },
  { label: "Чтение", href: "#reading" },
  { label: "Как проходит", href: "#process" },
  { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={
        "fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,padding] duration-500 " +
        (scrolled
          ? "border-b border-charcoal/10 bg-ivory/85 py-4 backdrop-blur-md"
          : "border-b border-transparent bg-transparent py-6")
      }
    >
      <nav className="mx-auto flex max-w-[1240px] items-center justify-between px-6 md:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-serif text-xl tracking-tight text-charcoal transition-opacity hover:opacity-70 md:text-2xl"
        >
          Ольга&nbsp;Щербич
        </a>

        <div className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.slice(1)}`}
              className="relative font-sans text-sm text-charcoal/70 transition-colors duration-300 hover:text-charcoal after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-sage after:transition-all after:duration-300 hover:after:w-full"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#booking"
            data-testid="nav-cta"
            className="border border-charcoal px-6 py-2.5 font-sans text-sm text-charcoal transition-colors duration-300 hover:bg-charcoal hover:text-ivory"
          >
            Записаться
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Меню"
          onClick={() => setOpen(true)}
          className="text-charcoal md:hidden"
        >
          <Menu className="h-6 w-6" strokeWidth={1.4} />
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="fixed inset-0 z-50 flex flex-col bg-ivory px-6 py-6 md:hidden"
          >
            <div className="flex items-center justify-between">
              <span className="font-serif text-xl text-charcoal">Ольга Щербич</span>
              <button
                data-testid="mobile-menu-close"
                aria-label="Закрыть"
                onClick={() => setOpen(false)}
                className="text-charcoal"
              >
                <X className="h-6 w-6" strokeWidth={1.4} />
              </button>
            </div>
            <div className="mt-16 flex flex-col gap-8">
              {LINKS.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${l.href.slice(1)}`}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.1 + i * 0.07 }}
                  className="font-serif text-4xl text-charcoal"
                >
                  {l.label}
                </motion.a>
              ))}
              <a
                href="#booking"
                onClick={() => setOpen(false)}
                data-testid="mobile-nav-cta"
                className="mt-6 inline-block w-fit border border-charcoal px-8 py-3.5 font-sans text-sm text-charcoal"
              >
                Записаться на консультацию
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
